export default __webpack_public_path__ + "static/media/mfa-recovery.b23ffc96.svg";